// normalize to transformer
export const transformersMapping = {
  textUcfirst: 'capitalize',
  emailAddress: 'lowercase', // I checked the legacy code and apparently it is all it does (https://bitbucket.org/overstappen/react-vergelijker/src/b5a7a33bd42501a5c507faf463de292d69386aa6/src/redux/normalizers/emailAddress.js?at=master#emailAddress.js-1,3)
  date: ['normalizeDate', 'numericToDate'],
  birthdate: ['normalizeDate', 'numericToDate'],
  phone: 'normalizePhone',
  zipcode: 'normalizePostalCode',
  iban: 'normalizeIBAN',
  initials: 'normalizeInitials',
  todaysDate: ['normalizeDate', 'numericToDate'],
  // text: '?',
};

export default transformersMapping;
